<style lang="scss" scoped>
.share {
    position: relative;
    line-height: 1;

    span {
        font-size: 1rem;
    }

    .whatsapp {
        &:before {
            content: url("/svg/whatsapp-circle-dark.svg");
        }
    }

    .linkedin {
        &:before {
            content: url("/svg/linkedin-circle-dark.svg");
        }
    }

    .facebook {
        &:before {
            content: url("/svg/facebook-circle-dark.svg");
        }
    }

    .email {
        &:before {
            content: url("/svg/email-circle-dark.svg");
        }
    }

    .messenger {
        &:before {
            content: url("/svg/messenger-circle-dark.svg");
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="text-center share">
            <span class="font-weight-bold">Deel deze story</span>
            <div class="mt-16 d-flex justify-content-center">
                <a target="_blank" :href="`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${story.title.rendered}`" class="linkedin mr-8"></a>
                <a target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`" class="facebook mr-8"></a>
                <a :href="`mailto:?subject=${story.title.rendered} - ToffeTeambuildings.be&amp;body=Lees hier de story: ${url}`" class="email mr-8"></a>
                <a :href="`whatsapp://send?text=${url}`" class="whatsapp mr-8 mr-lg-0"></a>
                <a :href="`fb-messenger://share/?link=${url}&app_id=123456789`" class="messenger d-lg-none"></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "elements.social-icons",

    props: {
        story: {
            type: Object,
            required: false,
        },
    },

    computed: {
        url() {
            return window.location.href;
        }
    }
}
</script>